import { CardContainer } from "@/components/commons/CardContainer";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { TMockExamDataStats } from "@/features/learning-content/types/learningContent";
import { text } from "@/theme/colors";
import { Stack, Typography, styled } from "@mui/material";
import { FC } from "react";

type TMockExamDataRegistrationStatsProps = {
  stats: TMockExamDataStats;
};

// Displays mock exam data registration statistics (matches design Frame 1000005243)
export const MockExamDataRegistrationStats: FC<TMockExamDataRegistrationStatsProps> = ({ stats }) => {
  return (
    <CardContainer sx={{ borderRadius: "8px" }}>
      <Stack gap={3}>
        <Typography variant="head20Bold">現在のデータ登録数</Typography>
        <InfoRow>
          <InfoItem>
            <ItemInfo
              label="科目数"
              value={stats.totalSubjectCount != null ? String(stats.totalSubjectCount) : ""}
              isShowDivider={false}
              endIcon={
                <Typography variant="body14" color={text.primary}>
                  科目
                </Typography>
              }
            />
          </InfoItem>
          <InfoItem>
            <ItemInfo
              label="問題数"
              value={stats.totalQuestionCount != null ? String(stats.totalQuestionCount) : ""}
              isShowDivider={false}
              endIcon={
                <Typography variant="body14" color={text.primary}>
                  問
                </Typography>
              }
            />
          </InfoItem>
          <InfoItem>
            <ItemInfo
              label="配点合計（満点）"
              value={stats.totalScoreSum != null ? String(stats.totalScoreSum) : ""}
              isShowDivider={false}
              endIcon={
                <Typography variant="body14" color={text.primary}>
                  点
                </Typography>
              }
            />
          </InfoItem>
        </InfoRow>
        <InfoRow>
          <InfoItem>
            <ItemInfo label="データの最終更新者" value={stats.lastImportBy} isShowDivider={false} />
          </InfoItem>
          <InfoItem>
            <ItemInfo label="データの最終更新日" value={stats.lastImportAt} isShowDivider={false} />
          </InfoItem>
          <InfoItem />
        </InfoRow>
      </Stack>
    </CardContainer>
  );
};

const InfoRow = styled(Stack)`
  flex-direction: row;
  gap: 24px;
`;

const InfoItem = styled(Stack)`
  flex: 1;
  gap: 4px;
`;
